/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Albumina View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AlbuminaView';

export const mapStateToPropsAlbumina = mapStateToProps;
export const mapDispatchToPropsAlbumina = mapDispatchToProps;

export default connect(
  mapStateToPropsAlbumina,
  mapDispatchToPropsAlbumina
)(View);
